import { createDecorator } from 'vue-class-component';

/**
 * @param {string} eventName
 * @param {*} [listenerOptions] - The options passed to the 3rd argument of EventTarget.addEventListener()
 * @param {EventTarget|function:EventTarget} [eventTarget=window] - The object to attach the event to, can be a factory function
 * @returns {VueDecorator}
 */
export function WindowEventListener(eventName, listenerOptions = undefined, eventTarget = window) {
    return createDecorator((options, key) => {
        const method = options.methods[key];
        options.mixins.push({
            data: () => ({
                WindowEventListeners: {
                    [key]: null,
                },
            }),
            created() {
                if (!this.WindowEventListeners[key]) {
                    this.WindowEventListeners[key] = method.bind(this);
                }
                const resolvedTarget =
                    typeof eventTarget === 'function' ? eventTarget() : eventTarget;
                resolvedTarget.addEventListener(
                    eventName,
                    this.WindowEventListeners[key],
                    listenerOptions,
                );
            },
            beforeDestroy() {
                console.assert(this.WindowEventListeners[key]);
                const resolvedTarget =
                    typeof eventTarget === 'function' ? eventTarget() : eventTarget;
                resolvedTarget.removeEventListener(
                    eventName,
                    this.WindowEventListeners[key],
                    listenerOptions,
                );
            },
        });
    });
}
